import { Link } from "@tanstack/react-router"
import { Avatar } from "~/components/ui/avatar"
import { RelativeTime } from "~/components/ui/relative-time"
import type { Group, Post, User } from "@apps/gwservice/types"

interface PostMetaProps {
  post: Post
  group?: Group
  author?: User
  date: string
  linkToPost?: boolean
}

export function PostMeta({ post, group, author, date, linkToPost }: PostMetaProps) {
  const avatar = <Avatar url={group?.avatar?.url} name={group?.name} variant="group-post" />
  return (
    <div className="flex items-center gap-m p-m">
      {group ? <Link to={"/group/" + group.id}>{avatar}</Link> : avatar}

      {linkToPost ? (
        <Link to={"/post/" + post.id} className="flex-1 min-w-0">
          <Texts group={group} author={author} date={date} />
        </Link>
      ) : (
        <Texts group={group} author={author} date={date} className="flex-1 min-w-0" />
      )}
    </div>
  )
}

type TextsProps = Pick<PostMetaProps, "group" | "author" | "date"> & { className?: string }

const Texts = ({ group, author, date, className }: TextsProps) => (
  <div className={`${className} flex items-center gap-m`}>
    <div className="flex flex-col leading-tight min-w-0">
      <div className="text-base truncate">{group?.name ?? "<УДАЛЕНО>"}</div>
      <div className="text-secondary truncate">{author?.name || (author ? "\u00a0" : "<УДАЛЕНО>")}</div>
    </div>
    <RelativeTime date={date} className="shrink-0 ml-auto text-muted-foreground text-xs" />
  </div>
)
